__turbopack_context__.v({
  "container": "Collapsible-module-scss-module__d0FwOG__container",
  "cta": "Collapsible-module-scss-module__d0FwOG__cta",
  "info": "Collapsible-module-scss-module__d0FwOG__info",
});
